!function (angular) {
    "use strict"

    var metaDataControllers = angular.module("controller.metadata", []);

    metaDataControllers.controller("metaDataController", ['$scope', 'metaDataService','$log', function ($scope, metaDataService,$log) {

        function initialize(){
            metaDataService.getMetaData()
                .then(function (metadata) {
                    $scope.metaData = metadata;
                }).catch(function (error) {
                $log.error("metaDataController: Error while getting metadata", error)
            });
        }

        $scope.$on('event:completed-login', function () {
            initialize()
        })
    }])
}(angular)
